export const audioProfiles = {
  speechStandard: "speech_standard",
  musicStandard: "music_standard",
  standardStereo: "standard_stereo",
  highQuality: "high_quality",
  highQualityStereo: "high_quality_stereo"
}

export const eventTypes = {
  preparing: "PreparingStream",
  streaming: "Streaming",
  finished: "FinishedStream",
  end: "EndStream"
}

export const states = {
  standby: "standby",
  live: "live",
  noLivestream: "noLivestream",
  ended: "ended"
}
